/**
 * Loveknots Wishlist Engine
 * Handles saving liked product handles in browser localStorage (last liked first)
 * Updates real-time counters and triggers UI states.
 */
(function () {
  const STORAGE_KEY = 'loveknots_wishlist';

  window.LoveknotsWishlist = {
    get: function () {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return [];
        const parsed = JSON.parse(stored);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.warn('[Wishlist] Error reading from localStorage', e);
        return [];
      }
    },

    set: function (items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        this.broadcast();
      } catch (e) {
        console.warn('[Wishlist] Error saving to localStorage', e);
      }
    },

    has: function (handle) {
      if (!handle) return false;
      return this.get().includes(handle);
    },

    add: function (handle) {
      if (!handle) return;
      let list = this.get();
      // Remove if existing to move to the front (last liked product first)
      list = list.filter(function (item) {
        return item !== handle;
      });
      list.unshift(handle);
      this.set(list);
    },

    remove: function (handle) {
      if (!handle) return;
      let list = this.get();
      list = list.filter(function (item) {
        return item !== handle;
      });
      this.set(list);
    },

    toggle: function (handle, buttonElement) {
      if (!handle) return false;
      const isLiked = this.has(handle);
      if (isLiked) {
        this.remove(handle);
        if (buttonElement) {
          buttonElement.classList.remove('is-active');
        }
      } else {
        this.add(handle);
        if (buttonElement) {
          buttonElement.classList.add('is-active');
          buttonElement.classList.add('just-liked');
          setTimeout(function () {
            buttonElement.classList.remove('just-liked');
          }, 500);
        }
      }
      this.updateButtons();
      return !isLiked;
    },

    broadcast: function () {
      const list = this.get();
      this.updateCount(list.length);
      window.dispatchEvent(
        new CustomEvent('wishlist:updated', {
          detail: { wishlist: list, count: list.length }
        })
      );
    },

    updateCount: function (count) {
      const total = typeof count === 'number' ? count : this.get().length;
      document.querySelectorAll('.wishlist-count').forEach(function (el) {
        el.textContent = total;
      });
      document.querySelectorAll('.wishlist-count-bubble').forEach(function (el) {
        if (total > 0) {
          el.style.display = 'flex';
        } else {
          el.style.display = 'none';
        }
      });
    },

    updateButtons: function () {
      const list = this.get();
      document.querySelectorAll('[data-product-handle]').forEach(function (btn) {
        const handle = btn.getAttribute('data-product-handle');
        if (handle && list.includes(handle)) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-label', 'Remove from wishlist');
        } else if (handle) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-label', 'Add to wishlist');
        }
      });
    },

    init: function () {
      this.updateCount();
      this.updateButtons();

      // Intercept clicks on wishlist buttons in capture phase
      document.addEventListener(
        'click',
        function (e) {
          var btn = e.target.closest('.card-wishlist-btn, [data-wishlist-button]');
          if (btn) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var handle = btn.getAttribute('data-product-handle');
            if (handle) {
              window.LoveknotsWishlist.toggle(handle, btn);
            }
          }
        },
        true
      );

      // Listen for storage changes across tabs
      window.addEventListener('storage', (e) => {
        if (e.key === STORAGE_KEY) {
          this.updateCount();
          this.updateButtons();
        }
      });
    }
  };

  // Helper function for inline card onclick
  window.toggleWishlist = function (handle, btn) {
    return window.LoveknotsWishlist.toggle(handle, btn);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.LoveknotsWishlist.init();
    });
  } else {
    window.LoveknotsWishlist.init();
  }
})();
